import React, { useEffect, useState } from 'react';
import { Header } from '../../components/Header';
import { Loading } from '../../components/Loading';
import { Text,TextOnly } from '../../components/Text';
import { formatOemHealthLast24HoursDate, formatOemHealthLast7DaysDate } from '../../libs/utils';
import { useOemHealth } from '../../context/OEMHealth';
import HelpTooltip from '../../components/Tooltips/HelpTooltip';

const OemHealth = () => {
  const { isOemHealthLoading, oemList, handleRefresh } = useOemHealth();
  const [search, setSearch] = useState<string>('');

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value);
  };

  const [oemListData, setOemListData] = useState<any[]>([]);

  const handleRefreshOemHealth = async () => {
    if (!isOemHealthLoading) {
      await handleRefresh(true);
    }
  };

  useEffect(() => {
    setOemListData(oemList);
  }, [oemList]);

  return (
    <>
      <Header title={TextOnly('oemHealth')} />
      <div className="l-container">
        <div className="l-flex-wrap">
          <div className="l-flex-row-wrap">
            <div className="l-flex-align-center u-margin-right">
              {TextOnly('key')}:
            </div>
            <div className={`oem-service-level oem-service-level--good`}>
              {TextOnly('good')}
            </div>
            <div className={`oem-service-level oem-service-level--degraded`}>
              {TextOnly('degraded')}
            </div>
            <div className={`oem-service-level oem-service-level--down`}>
              {TextOnly('down')}
            </div>
          </div>
          <div className="l-flex-end l-flex-row-center">
            <HelpTooltip 
              label={'Refresh OEM Health'} 
              child={
                <i 
                  className={`${!isOemHealthLoading ? 'clickable' : 'disable-button'} refresh-icon fa fa-arrow-rotate-right u-margin-right`} 
                  onClick={() => handleRefreshOemHealth()}
                />
              }
            />
            <div className="c-field u-margin-bottom-none">
              <label htmlFor="search" className="c-field__label u-is-vishidden">
                <Text tid="search" />
              </label>
              <input
                type="text"
                id="search"
                maxLength={50}
                className="c-input"
                placeholder={TextOnly('search')}
                value={search}
                onChange={handleChange}
              />
              <i className="c-field__input-icon fal fa-search" />
            </div>
          </div>
        </div>

        {isOemHealthLoading 
          ? <Loading />
          : <div className="u-margin-top-large">
              {oemListData
                ?.filter((oem: any) =>
                  oem?.filterString?.includes(search?.toLowerCase())
                )
                ?.map((oem: any) => (
                  <div className="c-stats-widget u-max-width-none u-margin-bottom-large">
                    <div className="h2 c-stats-widget__title u-margin-top-large">
                      {oem?.oemName} - {oem?.regionName}
                    </div>
                    <div className="l-flex-column u-margin-top-large u-margin-bottom-large">
                      <div className="c-stats-widget__label">
                        {TextOnly('last24Hours')}
                      </div>
                      <div className="l-flex-row-wrap">
                        {oem?.last24Hours?.map((status: any) => (
                          <div
                            className={`oem-service-level oem-service-level--${status?.serviceLevel?.toLowerCase()}`}
                          >
                            {formatOemHealthLast24HoursDate(status?.date)}
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="l-flex-column u-margin-top-large u-margin-bottom-large">
                      <div className="c-stats-widget__label">
                        {TextOnly('last7Days')}
                      </div>
                      <div className="l-flex-row-wrap">
                        {oem?.last7Days?.map((status: any) => (
                          <div
                            className={`oem-service-level oem-service-level--${status?.serviceLevel?.toLowerCase()}`}
                          >
                            <div className="l-flex-column">
                              <div className="">
                                {formatOemHealthLast7DaysDate(status?.date)}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                ))}
            </div>
        }
      </div>
    </>
  );
};

export default OemHealth;